module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container_flex content__container"
  }, _vm._l((_vm.db), function(sublist, header, index) {
    return _c('div', {
      staticClass: "content__wrapper content__wrapper_height"
    }, [_c('ul', {
      key: index,
      staticClass: "content__list"
    }, [_c('h3', {
      staticClass: "content__header"
    }, [_vm._v(_vm._s(header))]), _vm._v(" "), _c('span', {
      staticClass: "content__index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _vm._l((sublist), function(item) {
      return _c('li', {
        staticClass: "content__sublist"
      }, [_c('img', {
        staticClass: "content__img",
        attrs: {
          "src": './src/assets/icons/' + item.thumbnail,
          "alt": item.name
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "content__link",
        attrs: {
          "href": item.link,
          "target": "_blank"
        }
      }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])])
    }), _vm._v(" "), _c('a', {
      staticClass: "content__showList",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showList.apply(null, arguments)
        }
      }
    }, [_vm._v("\n          show\n        ")])], 2)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-538a5931","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 72
// module chunks = 0